// Module
var code = "<div class=\"form-input-currency input-currency\"> <input id=\"vm.id\" text-format=\"number\" class=\"form-control form-linear-grad referral-fee-input\" placeholder=\"{{ vm.placeholder }}\" ng-model=\"vm.model\" ng-blur=\"vm.onBlur({ value: vm.model })\" ng-change=\"vm.onChange({ value: vm.model })\" ng-disabled=\"vm.isDisabled\"/> </div> ";
// Exports
module.exports = code;